import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getDictionary,
  getTechnicalReferenceContacts,
  getAllDictionaries,
  getDictionaryByNameAndType,
  createDictionary,
  updateDictionary,
} from "services/dictionary";

export const GET_DICTIONARY = createAsyncThunk(
  "@@DICTIONARIES/GET_DICTIONARY",
  async (params, thunkAPI) => {
    const state = thunkAPI.getState();
    const { type } = params;
    if (!state?.dictionaries[type]) {
      if (type === "TECHNICAL_CONTACT") {
        const response = await getTechnicalReferenceContacts();
        return { ...state?.dictionaries, [type]: response?.data };
      } else {
        const response = await getDictionary({ ...params, no_graphic: true });
        if (response?.data)
          return { ...state?.dictionaries, [type]: response?.data };
      }
    }
    return { [type]: state?.dictionaries[type] };
  }
);

export const GET_ALL_DICTIONARIES = createAsyncThunk(
  "@@DICTIONARIES/GET_ALL_DICTIONARIES",
  async (params, thunkAPI) => {
    const response = await getAllDictionaries(params);
    return response?.data || [];
  }
);

export const GET_DICTIONARY_BY_NAME_AND_TYPE = createAsyncThunk(
  "@@DICTIONARIES/GET_DICTIONARY_BY_NAME_AND_TYPE",
  async ({ name, type }, thunkAPI) => {
    const response = await getDictionaryByNameAndType(name, type);
    return response?.data;
  }
);

export const CREATE_DICTIONARY = createAsyncThunk(
  "@@DICTIONARIES/CREATE_DICTIONARY",
  async (dictionaryData, thunkAPI) => {
    const response = await createDictionary(dictionaryData);
    return response?.data;
  }
);

export const UPDATE_DICTIONARY = createAsyncThunk(
  "@@DICTIONARIES/UPDATE_DICTIONARY",
  async (dictionaryData, thunkAPI) => {
    const response = await updateDictionary(dictionaryData);
    return response?.data;
  }
);

const dictionaries = createSlice({
  name: "@@DICTIONARIES",
  initialState: {
    allDictionaries: [],
    loading: false,
    error: null,
  },
  reducers: {
    ADD_DICTIONARY: (state, action) => {
      state.allDictionaries.push(action.payload);
    },
    MODIFY_DICTIONARY: (state, action) => {
      const index = state.allDictionaries.findIndex(
        dict =>
          dict.name === action.payload.name && dict.type === action.payload.type
      );
      if (index !== -1) {
        state.allDictionaries[index] = action.payload;
      }
    },
    REMOVE_DICTIONARY: (state, action) => {
      state.allDictionaries = state.allDictionaries.filter(
        dict =>
          !(
            dict.name === action.payload.name &&
            dict.type === action.payload.type
          )
      );
    },
  },
  extraReducers: builder => {
    builder
      .addCase(GET_DICTIONARY.fulfilled, (state, action) => {
        return { ...state, ...action.payload };
      })
      .addCase(GET_ALL_DICTIONARIES.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(GET_ALL_DICTIONARIES.fulfilled, (state, action) => {
        state.loading = false;
        state.allDictionaries = action.payload;
      })
      .addCase(GET_ALL_DICTIONARIES.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(CREATE_DICTIONARY.fulfilled, (state, action) => {
        state.allDictionaries.push(action.payload);
      })
      .addCase(UPDATE_DICTIONARY.fulfilled, (state, action) => {
        const index = state.allDictionaries.findIndex(
          dict =>
            dict.name === action.payload.name &&
            dict.type === action.payload.type
        );
        if (index !== -1) {
          state.allDictionaries[index] = action.payload;
        }
      });
  },
});

export const { ADD_DICTIONARY, MODIFY_DICTIONARY, REMOVE_DICTIONARY } =
  dictionaries.actions;
export default dictionaries.reducer;
